import { render, staticRenderFns } from "./ReadOnlyModal.vue?vue&type=template&id=d54dfc44"
import script from "./ReadOnlyModal.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyModal.vue?vue&type=script&lang=ts"
import style0 from "./ReadOnlyModal.vue?vue&type=style&index=0&id=d54dfc44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports